module.exports = __webpack_public_path__ + "img/list_arrow_right.57b417f0.svg";